import smartlookClient from 'smartlook-client'
import {config} from '../shared/config';

const Smartlook = () => {

    const getCookie = (name) => {

        const cookieArr = document.cookie.split(';');
        let cookiePair;

        cookieArr.map((cookie =>{
            cookiePair = cookie.split('=')
            if (name === cookiePair[0].trim()) {
                return decodeURIComponent(cookiePair[1]);
            }
            return null;})
        )

        return null;
    }

    const InitSmartlook = () =>{
        const cookie = getCookie('OptanonConsent');
        let performanceCookieValue = 1;
        let recordScriptFlag;

        if(cookie!==null) {
            cookie.split('&').forEach(element => {
                if (element.includes('groups=')){
                    element.split(',').forEach(element => {
                        if (element.includes('C0002')) {
                            performanceCookieValue = element.split(':');
                        }
                    });
                }
            });

            if(performanceCookieValue[1]===1){
                recordScriptFlag=true;
            } else {
                recordScriptFlag=false;
            }

        } else {
            recordScriptFlag=true;
        }


        if (!smartlookClient.initialized() && recordScriptFlag) {
            if(config.isDevelopmentEnvironment){
                smartlookClient.init('7f3c19eac9e239b6ba0981db252da7faa7b5f362', { region: 'eu' });
                smartlookClient.anonymize();
            }
            else if(config.isProductionEnvironment){
                smartlookClient.init('af904ec8305541c1d7c3aceed3f5ab9b2c175ff8', { region: 'eu' });
                smartlookClient.anonymize();
            }
            else if(config.isQualityEnvironment){
                smartlookClient.init('3e794448447babc6f9b922a28ccacc9771b9efe4', { region: 'eu' });
                smartlookClient.anonymize();
            }
        }else{
            smartlookClient.disable(true);
        }
        return null
    }

    return InitSmartlook()
}

export default Smartlook;
